import React, { useState } from 'react'
import { WizardBase } from './WizardBase'

import _ from 'lodash'
import InformazioniPreliminari from './InformazioniPreliminari'
import Demolizione from './Demolizione'
import Costruzione from './Costruzione'
import Impianti from './Impianti'
import Installazione from './Installazione'
import Bagni from './Bagni'
import Cucine from './Cucine'

import { useHistory } from 'react-router-dom'
import Serramenti from './Serramenti'
import { useToast } from '../contexts/ToastContext'


export const WizardAppartamentoVilla = (props) => {

    const { showToast } = useToast();
    const history = useHistory();
    const [preventivo, setPreventivo] = useState(props.preventivo || 
        {
            infoPrel: undefined,
            rifacimentoTetto: undefined,
            demolizione: undefined,
            costruzione: undefined,
            impianti: undefined,
            bagni: [],
            cucine: [],
            installazione: undefined,
            serramenti: undefined, 
            amministrazione: undefined, 
        }
    )
    const [errorMsg, setErrorMsg] = useState(null)


    const handleChange = (name) => (event) => {

        console.log("wizard handle change", event)
        //setLaboratorio({ ...laboratorio, [name]: event.target.value })
    }

    const handleConcludi = () => {
        history.replace("/preventivo", { preventivo: preventivo })
        onExit()
    }

   /*  useEffect(() => {
        console.log('updated preventivo', preventivo)
    }, [preventivo]) */


    // validation wizard
    const validate = () => {
        let errors = {}
        /*if (!laboratorio.data_inizio_iscr_do)
            errors.data_inizio_iscr_do = "Data inizio iscrizioni obbligatoria"
        if (!laboratorio.data_fine_iscr_do)
            errors.data_fine_iscr_do = "Data fine iscrizioni obbligatoria"
        if (!laboratorio.data_inizio_do)
            errors.data_inizio_do = "Data inizio  obbligatoria"
        if (!laboratorio.data_fine_iscr_do)
            errors.data_fine_iscr_do = "Data fine obbligatoria"
        if (!laboratorio.lingua_fltp || laboratorio.lingua_fltp.length === 0)
            errors.lingua_fltp = "Lingua obbligatoria"
        if (!laboratorio.persona_docente_id || laboratorio.persona_docente_id.length === 0)
            errors.persona_docente_id = "Docente obbligatorio"
        if (!laboratorio.tipologia_corso_id || laboratorio.tipologia_corso_id.length === 0)
            errors.tipologia_corso_id = "Tipologia Lab obbligatoria"
        if (!laboratorio.link_aula_virtuale || laboratorio.link_aula_virtuale.length === 0)
            errors.link_aula_virtuale = "Link aula virtuale  obbligatorio"
       */

        return errors
    }



    function onExit() {
        props.onExit()
    }

    const accept = () => {
        showToast({
            severity: 'info',
            summary: 'accettata',
            detail: 'accetta',
            life: 3000
        })
    }

    const reject = () => {
        showToast({
            severity: 'error',
            summary: 'Rifiutata',
            detail: 'rifiutata',
            life: 3000
        })
    }

    return (
        <div>
            <WizardBase
                id='wizardAppartamentoVilla'
                //onChange={handleChange}
                //values={occupazione}
                onWizardComplete={handleConcludi}
                onExit={onExit}
                steps={[
                    {
                        label: "Info",
                        component: (
                            <InformazioniPreliminari tipologia={props.tipologia} preventivo={preventivo}
                                onChange={(info, tetto, amministrazione) => setPreventivo({ ...preventivo, infoPrel: info, rifacimentoTetto: tetto, amministrazione: amministrazione })} />
                        )
                    },
                    {
                        label: "Demolizione",
                        component: (
                            <Demolizione
                                preventivo={preventivo}
                                onChange={(data) => setPreventivo({ ...preventivo, demolizione: data })} />

                        )
                    },

                    {
                        label: "Costruzione",
                        component: (
                            <Costruzione
                                preventivo={preventivo}
                                onChange={(data) => setPreventivo({ ...preventivo, costruzione: data })} />

                        )
                    },
                    {
                        label: "Impianti",
                        component: (
                            <Impianti preventivo={preventivo}
                                onChange={(data) => setPreventivo({ ...preventivo, impianti: data })} />

                        )
                    },
                   
                    {
                        label: "Bagno",
                        // andrebbe ripensata la funziona calcola per array
                        component: (
                            <Bagni preventivo={preventivo}
                                onChange={(data) => setPreventivo({ ...preventivo, bagni: data })} />
                        )
                    },
                    {
                        label: "Cucina",
                        component: (
                        <Cucine preventivo={preventivo}
                            onChange={(data) => setPreventivo({ ...preventivo, cucine: data })} />

                        )
                    },
                    {
                    label: "Installazione",
                    component: (
                        <Installazione preventivo={preventivo}
                            onChange={(data) => setPreventivo({ ...preventivo, installazione: data })} />

                    )
                    },
                    {
                        label: "Serramenti",
                        component: (
                            <Serramenti preventivo={preventivo}
                                onChange={(data) => setPreventivo({ ...preventivo, serramenti: data })} />
    
                        )
                        },
                  /*  {
                        label: "Amministrazione",
                        component: (
                            <Amministrazione />

                        )
                    }*/

                ]}
                errorMsg={errorMsg}
                setErrorMsg={setErrorMsg}
                msgConfirmExit='Messaggio di uscita'
            />

        </div>
    )
}
